import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from '../../components/loader';
import EurTrade from './index';

class EurTradePrereq extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { assets, pairs } = this.props;

    const assetsReady = (assets && assets.length);
    const pairsReady = (pairs && Object.keys(pairs).length !== 0);
    if (assetsReady && pairsReady) {
      return (
        <EurTrade />
      );
    }
    return (
      <div>
        <div className="grid-x vt-automate">
          <div className="cell panel small-12 medium-12 large-12">
            <div className="center-loader">
              <Loader logo />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(EurTradePrereq));
